import $ from 'jquery'
import React from 'react'


/**
 * @param choices list of str
 * @param values object with keys (like in choices) with booleanish values
 * @param onClick function(values)
 */
function MultiSelector({choices, values, onClick}) {

    function _onClick(event, choice) {
        event.preventDefault();
        if (onClick) {
            const new_values = {
                ...values,
                [choice]: !values[choice],
            };
            onClick(new_values);
        }
    };

    return (
        <div className={"selector"}>
            {choices.map((choice, i) => (
                <div
                    key={i}
                    className={"choice" + (values[choice] ? " selected": "")}
                    onClick={(e)=>{_onClick(e, choice)}}
                >{choice}</div>
            ))}
        </div>
    );
}

export default MultiSelector


// WEBPACK FOOTER //
// ./cms_plugins/expert_search/js/components/MultiSelector.js